import axiosInstance from '../../axios-config';

const educationApi = '/api/patients/{0}/education';
const getViewPreferenceApi = '/api/users/{0}/Preferences?name={1}';
const setViewPreferenceApi = '/api/users/{0}/Preferences';
const articleContentUrl = '/api/education/articles/{0}/content?token={1}';
const articleReadUrl = '/api/education/articles/{0}/read';

const viewPreferenceName = 'EducationMaterials_EducationPreviewSetting';

export const getEducationArticles = (patientId, showArchived) => {
  if (showArchived !== true) {
    return axiosInstance.get(educationApi.replace('{0}', patientId));
  }

  return axiosInstance.get(educationApi.replace('{0}', patientId) + '?includeArchived=true');
};

export const getUnreadArticleCount = (patientId) => (
  axiosInstance.get((educationApi + '/UnreadCount').replace('{0}', patientId))
);

export const getArchivedArticleCount = (patientId) => (
  axiosInstance.get((educationApi + '/ArchivedCount').replace('{0}', patientId))
);

export const getArticleContentUrl = (articleId, accessToken) => (
  axiosInstance.defaults.baseURL +
  articleContentUrl
    .replace('{0}', articleId)
    .replace('{1}', accessToken)
);

export const setViewPreference = (userId, value) =>
  axiosInstance.put(setViewPreferenceApi.replace('{0}', userId), {
    userId,
    name: viewPreferenceName,
    value,
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.data);

export const getViewPreference = (userId) =>
  axiosInstance.get(getViewPreferenceApi
    .replace('{0}', userId)
    .replace('{1}', viewPreferenceName)
  );

export const putMarkArticleAsRead = (articleId) =>
  axiosInstance.put(articleReadUrl
    .replace('{0}', articleId)
  );